import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Handle ChunkLoadError (occurs when lazy-loaded modules fail to load after deployment)
window.addEventListener('unhandledrejection', event => {
  if (event.reason?.name === 'ChunkLoadError') {
    const lastReload = sessionStorage.getItem('chunkErrorReload');
    const now = Date.now();

    // Only reload if last reload was more than 10 seconds ago (prevents infinite loops)
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('chunkErrorReload', now.toString());
      console.warn('Chunk load failed, reloading application:', event.reason.message);
      event.preventDefault();
      window.location.reload();
    }
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
